import React, { useState } from 'react'
import { Alert, Col, Divider, Row } from 'antd'
import {
  Checkbox,
  Form,
  FormItem,
  Input,
  Radio,
  SubmitButton,
} from 'formik-antd'
import { Formik } from 'formik'
import { EmployeeFormData } from '../../../services/api/employees'
import { APIError, isValidationError } from '../../../services/api/client/types'
import { ManOutlined, WomanOutlined } from '@ant-design/icons'
import { NameInput } from './NameInput'
import CompanySelectContainer from './CompanySelect'
import { CountrySelect } from './CountrySelect/CountrySelect'
import { BirthdateSelect } from './BirthdateSelect/BirthdateSelect'
import { PhoneInput } from './PhoneInput'
import moment from 'moment'

type Props = {
  initialValues: EmployeeFormData
  error: APIError | null
  onSubmit: (form: EmployeeFormData, ...args: any[]) => void
  onCompanyChange: (companyId?: string) => void
}

export const View: React.FunctionComponent<Props> = ({
  initialValues,
  error,
  onSubmit,
  onCompanyChange,
}) => {
  const [middleNameDisabled, setMiddleNameDisabled] = useState<boolean>(false)
  const [birthdate, setBirthdate] = useState<moment.Moment | null>(null)

  return (
    <Formik<EmployeeFormData> initialValues={initialValues} onSubmit={onSubmit}>
      <Form layout="vertical" size="large">
        {error && !isValidationError(error) ? (
          <Row gutter={[0, 16]}>
            <Col span={16}>
              <Alert message="Ошибка при сохранении профиля" type="error" />
            </Col>
          </Row>
        ) : null}

        <Row gutter={[32, 0]}>
          <Col span={16}>
            <FormItem name="companyId" label="Компания" required>
              <CompanySelectContainer
                companyId={initialValues.companyId}
                onCompanyChange={onCompanyChange}
              />
            </FormItem>
          </Col>
        </Row>

        <Divider />

        <Row gutter={[32, 0]}>
          <Col span={6}>
            <FormItem name="lastNameRu" label="Фамилия" required>
              <NameInput
                name="lastNameRu"
                translitTarget="lastNameEn"
                placeholder="Фамилия"
              />
            </FormItem>
          </Col>
          <Col span={6}>
            <FormItem name="firstNameRu" label="Имя" required>
              <NameInput
                name="firstNameRu"
                translitTarget="firstNameEn"
                placeholder="Имя"
              />
            </FormItem>
          </Col>
          <Col span={6}>
            <FormItem name="middleNameRu" label="Отчество">
              <NameInput
                name="middleNameRu"
                placeholder="Отчество"
                disabled={middleNameDisabled}
              />
            </FormItem>
          </Col>
          <Col span={6}>
            <FormItem name="skipMiddleName" label=" ">
              <Checkbox
                name="skipMiddleName"
                onChange={(e: any) => setMiddleNameDisabled(e.target.checked)}
              >
                Без отчества
              </Checkbox>
            </FormItem>
          </Col>
        </Row>

        <Row gutter={[32, 0]}>
          <Col span={6}>
            <FormItem name="lastNameEn" label="Фамилия на латинском" required>
              <Input name="lastNameEn" placeholder="Фамилия на латинском" />
            </FormItem>
          </Col>
          <Col span={6}>
            <FormItem name="firstNameEn" label="Имя на латинском" required>
              <Input name="firstNameEn" placeholder="Имя на латинском" />
            </FormItem>
          </Col>
          <Col span={8}>
            <FormItem name="gender" label="Пол" required>
              <Radio.Group name="gender">
                <Radio name="gender" value="male">
                  <ManOutlined />
                </Radio>
                <Radio name="gender" value="female">
                  <WomanOutlined />
                </Radio>
              </Radio.Group>
            </FormItem>
          </Col>
        </Row>

        <Row gutter={[32, 0]}>
          <Col span={6}>
            <BirthdateSelect value={birthdate} setValue={setBirthdate} />
          </Col>
          <Col span={6}>
            <CountrySelect />
          </Col>
        </Row>

        <Row gutter={[32, 0]}>
          <Col span={6}>
            <FormItem name="email" label="Электронная почта">
              <Input name="email" placeholder="test@example.com" />
            </FormItem>
          </Col>
          <Col span={6}>
            <FormItem name="phoneNumber" label="Телефонный номер">
              <PhoneInput />
            </FormItem>
          </Col>
        </Row>

        <Divider />

        <SubmitButton>Сохранить</SubmitButton>
      </Form>
    </Formik>
  )
}
